import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import { toast } from "react-toastify";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export async function downloadReversePDW(
    industryId: undefined|string|null,
    channelKey:string,
    categoryId: string,
    attributeString?: string,
    ): Promise<[boolean, null|{
        done: boolean,
        jobid: string,
        message: string
}]> { 
    try{
        if(!industryId || !categoryId) throw new Error("Request failed: Invalid category or industry id for PDW")
        let url = `${api_base_url}pdw/reverse/${industryId}/${categoryId}/${channelKey}${attributeString?.trim() !== "" ? `?attr_val_ids=${attributeString}` : ""}`;
        let res = await ServiceWrapper.doGet(
            url,
            null,
            null,
            AuthManager.getGmsToken()
        );
        
        // error check
        if(res?.errorfound || !res.data?.jobid) throw new Error("PDW download failed")

        return [true, res?.data ?? null]
    }
    catch(err: any){
        console.error(err.message ?? "Unknown PDW error")
        toast.error(err.message)
        return [false, null]
    }
}


export async function deleteProductsByPDW(
    file: File,
    channelKey:string,
    ): Promise<{
        done: boolean,
        jobid: string,
        message: string
}> { 
    return new Promise(async (resolve, reject) => {
        if(!file) reject("No file specified")
        
        const formData = new FormData();
        formData.append("file", file);
        let res = await ServiceWrapper.doPost(
            api_base_url + `pdw/upload/deleteproducts/${channelKey}`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );

        if(res.errorfound || !res.data.done) reject(res?.data?.message ?? "Error deleting")
        resolve(res.data)
    })
}

export async function downloadPDW(
    categoryId: string,
    channelKey: string,
    allowAttributes: boolean = false
    ): Promise<[boolean, null|{
        done: boolean,
        jobid: string,
        message: string
}]> { 
    return new Promise(async (resolve, reject) => {
        if(!categoryId) throw new Error("Request failed: Invalid category or industry id for PDW")
        
        let url = `${api_base_url}pdw/download/${categoryId}/${channelKey}${allowAttributes ? '?allow_attributes=true' : ""}`;
        let res = await ServiceWrapper.doGet(
            url,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if(res.errorfound || !res.data.done) reject(new Error(res?.data?.message ?? "PDW download failed"))
        resolve(res.data)
    })
}